function getBrowserLanguage() {
  return (
    navigator.language.split('-')[0]
  );
}

export default getBrowserLanguage;
